<script lang="ts">
	import { getContext } from 'svelte'
	import type { Writable } from 'svelte/store'

	export let cls = ''

	//Props
	export let submit = false
	export let disabled = false
	export let formaction: string | null = null
	export let icon = true
	export let wrapText = false
	export let testid: string | null = null

	//Stores
	export let loading: Writable<boolean> = getContext('loading')

	//Classes
	export let type = 'btn-filled-primary'
	export let shape = 'btn-rounded'
	export let animation = 'white'
</script>

<button
	data-testid={testid}
	type={submit ? 'submit' : null}
	class="btn appearance-none {cls} {type} {shape} min-h-[42px] {wrapText
		? 'whitespace-normal leading-tight'
		: ''}"
	class:loading={$loading}
	on:click
	{disabled}
	{formaction}
>
	{#if $loading}
		<img src="/images/animation/loading/{animation}.svg" alt="Načítání" class="w-12" />
	{:else}
		{#if icon}
			<img src="/images/icons/arrow/send.svg" alt="Šipka" class="mr-2 w-6" />
		{/if}
		<slot />
	{/if}
</button>
